import { Flex } from '@zenchef/styled-system/jsx'
import { HoverDelay } from '@zenchef/ui'
import { Children, cloneElement, PropsWithChildren, ReactElement } from 'react'

interface ReferenceProps extends PropsWithChildren {
  onMouseOver: any
  onMouseOut: any
  reference: any
  delay?: number
  fullWidth?: boolean
}

export const Reference = ({
  children,
  onMouseOver,
  onMouseOut,
  reference,
  delay = 300,
  fullWidth = false
}: ReferenceProps) => {
  const childrenWithRef = Children.map(children, function (child: ReactElement) {
    return cloneElement(child, { ref: reference.ref })
  })
  return (
    <HoverDelay onMouseOver={onMouseOver} onMouseOut={onMouseOut} delay={delay}>
      <Flex width={fullWidth ? '100%' : 'auto'} align='center' justify='center'>
        {childrenWithRef}
      </Flex>
    </HoverDelay>
  )
}
